import { render, staticRenderFns } from "./MemberGroupCard.vue?vue&type=template&id=183b2278&scoped=true&"
import script from "./MemberGroupCard.vue?vue&type=script&lang=ts&"
export * from "./MemberGroupCard.vue?vue&type=script&lang=ts&"
import style0 from "./MemberGroupCard.vue?vue&type=style&index=0&id=183b2278&scoped=true&lang=scss&"
import style1 from "./MemberGroupCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183b2278",
  null
  
)

export default component.exports